import { useSearchParams } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const PaymentMethodsPage = () => {
  const [searchParams] = useSearchParams();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}
      
      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 md:px-0 flex flex-col justify-start items-start gap-[60px] overflow-hidden">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="justify-center text-black text-[40px] font-bold leading-[60px]">支払い方法について</div>
            <div className="h-[3px] w-full relative bg-[#e4e4e4]" />
            <div className="w-full justify-center text-black text-base font-normal leading-7">
              DONDONでは、クレジットカード決済をご利用いただけます。<br/>
              詳細については下記をご覧ください。
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">クレジットカード決済について</div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">対象</div>
              <div className="self-stretch pl-5 inline-flex justify-center items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">全ての商品</div>
              </div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">ご利用可能なクレジットカード</div>
              <div className="self-stretch flex flex-col justify-center items-start gap-2.5">
                <img className="h-20" src="/images/terms/payment_methods_1.jpg" alt="ホルダーに軽微な傷" />
                <div className="flex-1 ml-5 justify-center text-black text-base font-normal leading-7">
                  DONDONでは、3Dセキュアに対応している以下のクレジットカードをご利用いただけます。<br/>
                  VISA / MasterCard / JCB / AMEX / DinersClub
                </div>
              </div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">決済のタイミング</div>
              <div className="self-stretch pl-5 inline-flex justify-center items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  ・ご購入時には、クレジットカードの与信枠が一時的に確保され、商品がDONDONから発送されるタイミングで決済（引き落とし）処理が行われます。<br/>
                  ・鑑定不通過などにより取引がキャンセルとなった場合は、クレジットカードの与信枠の確保は即時解除され、決済（引き落とし）は行われません。
                </div>
              </div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">注意事項</div>
              <div className="self-stretch pl-5 inline-flex justify-center items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  ・ご購入手続きが完了しない場合は、ご利用のクレジットカードの決済機能に制限がかかっている可能性があります。まずは、ご契約のクレジットカード会社へお問い合わせください。<br/>
                  ・クレジットカード会社へご確認いただいても問題が解決しない場合は、DONDON事務局までお問い合わせください。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {!isMobile && <Footer />}
    </div>
  );
};

export default PaymentMethodsPage;